/**
 * todo 沙龙问卷 状态库
 * @type {{mutations: {setUserName(*, {userName: *}): void, setClientId(*, {clientId: *}): void}, name: string, state: {clientId: string, userName: string}, getters: {}, actions: {}}}
 */

function getDefaultUserValues() {
  return {
    username: "",
    idNo: "",
    idType: "",
    gender: "",
    mobile: "",
    directManagerId: "",
    resultId: [],
    ofTypeIdList: []
  }
}

function getDefaultRiskResult() {
  return {
    riskLevel: "",
    riskGrades: "",
    qualified: false,
    descriptionList: [],
    complete: false,
    resultId:''
  }
}


const ManagerRiskQuestionStore = {
  namespaced: true,
  name: "mrqModule",
  state: {
    clientId: '',
    userValues: {
      username: "",
      idNo: "",
      idType: "",
      gender: "",
      mobile: "",
      directManagerId: "",
      resultId: [],
      ofTypeIdList: []
    },
    riskResult: {
      riskLevel: "",
      riskGrades: "",
      qualified: false,
      descriptionList: [],
      complete: false,
      resultId:''
    }
  },
  getters: {},
  mutations: {
    setUserValues(state, params) {
      state.userValues = {
        ...state.userValues,
        ...params
      }
    },
    setClientId(state, {clientId}) {
      state.clientId = clientId
    },
    setRiskResult(state, riskResult) {
      state.riskResult = {...state.riskResult, ...riskResult}
    },
    clearRiskResult(state){
      state.riskResult = getDefaultRiskResult()
    },
    clearAll(state) {
      state.clientId = ''
      state.userName = ''
      state.userValues = getDefaultUserValues()
      state.riskResult = getDefaultRiskResult()
    }
  },
  actions: {}
}

export default ManagerRiskQuestionStore
